import breakpoints from '@carvana/merch-tailwind/breakpoints';
import TrackWrapper from '~/components/common/TrackWrapper';
import { appAssetsCdnUrl } from '~/constants/environment';
import { useGetUser, useIsLoggedIn } from '~/context/common/UserContext';
import useTrackHeroPerformance from '~/hooks/home/telemetry/useTrackHeroPerformance';
import optimizeImage from '~/utilities/optimizeImage';
import {
  HeroContentContainer,
  HeroImage,
  HeroImageContainer,
  HeroWrapper,
  WelcomeBack,
  WelcomeBackWrapper
} from './Hero.styles';
import SearchBar from '../../common/SearchBar';

export default function Hero() {
  useTrackHeroPerformance();
  const isLoggedIn = useIsLoggedIn();
  const user = useGetUser();

  const viewEvent = {
    eventName: 'Home Feed Section',
    customAttributes: {
      action: 'viewed',
      section: 'Hero'
    }
  };

  const heroImg = {
    desktop: optimizeImage(
      `${appAssetsCdnUrl}/images/home/hero-return-user-desktop.png`,
      {
        height: 350,
        format: 'auto',
        quality: 90
      }
    ),
    tablet: optimizeImage(
      `${appAssetsCdnUrl}/images/home/hero-return-user-tablet.png`,
      {
        height: 350,
        format: 'auto',
        quality: 90
      }
    ),
    mobile: optimizeImage(
      `${appAssetsCdnUrl}/images/home/hero-return-user-mobile.png`,
      {
        height: 500,
        format: 'auto',
        quality: 90
      }
    )
  };

  return (
    <TrackWrapper event={viewEvent} trackOnce>
      <HeroWrapper>
        <HeroImageContainer>
          <HeroImage>
            <picture>
              <source
                media={`(min-width: ${breakpoints.md}px)`}
                srcSet={heroImg.desktop}
              />
              <source
                media={`(min-width: ${breakpoints.sm}px)`}
                srcSet={heroImg.tablet}
              />
              <img
                src={heroImg.mobile}
                alt="Hero Image with a Carvana Hauler driving through a neighborhood with a red SUV loaded on the back"
                className="h-full w-full object-contain object-right md:object-left"
                fetchPriority="high"
              />
            </picture>
          </HeroImage>
        </HeroImageContainer>
        <HeroContentContainer isLoggedIn={isLoggedIn}>
          <WelcomeBackWrapper>
            <WelcomeBack>
              Welcome back{isLoggedIn ? `,` : ''}
              <br />
              {isLoggedIn ? user?.given_name : ''}
            </WelcomeBack>
            <SearchBar />
          </WelcomeBackWrapper>
        </HeroContentContainer>
      </HeroWrapper>
    </TrackWrapper>
  );
}
